import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { JWTService } from './JWTService';
import { Store } from '@ngrx/store';
import { HTTT, HoaDon, TTHD, HTTTs, HD, HDHuy, CTHoaDon, FormatSoTien, VATCount, dsVAT, TongThanhToan } from '../models/bill.model';
import { ServerResponse, TPCloud_isNumber, catChuoi, TPCloud_getFormatDate, layTen } from '../models/types';
import { Result } from '@zxing/library';
import { element } from 'protractor';
import * as localForage from 'localforage';
import { GetLocalForageConFigService } from './getLocalForage.service';
import { async } from 'q';

@Injectable()
export class BillService {
  // splitted_receiptformat = [];
  receiptformat =
`Quầy: {TenQuay}           {NgayThangNam}
----------------------------------------
Đơn giá       Số lượng        Thành Tiền
{beginloop}
{MaHH}                   {LoaiVAT}
{TenHH}
{GiaBan}    {SoLuong}     {ThanhTienBan}
{GiaKM}
{endloop}
----------------------------------------
Tổng   {Sum(SoLuong)}   {Sum(TriGiaBan)}
Chiết khấu              {Sum(ChietKhau)}
Tổng tiền            {Sum(ThanhTienBan)}
Tiền khách trả    {Sum(SoTienThanhToan)}
Tiền trả lại      {Sum(TienTraLaiKhach)}
----------------------------------------
Chi tiết tiền thuế
VAT                              TienVAT
{beginloop_VAT}
{LoaiVAT}                    {TriGiaVAT}
{endloop_VAT}
----------------------------------------
Chi tiết thanh toán
{beginloop_TTHD}
{TenHinhThuc}          {SoTienThanhToan}
{ThongTinHinhThuc}
{endloop_TTHD}
{beginKHTV}
Khách hàng thành viên
Khách hàng                      {MaKHTV}
{endKHTV}
----------------------------------------
NV: {MaNV}
Tên NV: {TenNV}
Số HĐ:{SoHD}`;

  receiptformat_3inch =
`Quầy: {TenQuay}           {NgayThangNam}
----------------------------------------
Đơn giá       Số lượng        Thành Tiền
{beginloop}
{MaHH}                   {LoaiVAT}
{TenHH}
{GiaBan}    {SoLuong}     {ThanhTienBan}
{GiaKM}
{endloop}
----------------------------------------
Tổng   {Sum(SoLuong)}   {Sum(TriGiaBan)}
Chiết khấu              {Sum(ChietKhau)}
Tổng tiền            {Sum(ThanhTienBan)}
Tiền khách trả    {Sum(SoTienThanhToan)}
Tiền trả lại      {Sum(TienTraLaiKhach)}
----------------------------------------
Chi tiết tiền thuế
VAT                              TienVAT
{beginloop_VAT}
{LoaiVAT}                    {TriGiaVAT}
{endloop_VAT}
----------------------------------------
Chi tiết thanh toán
{beginloop_TTHD}
{TenHinhThuc}          {SoTienThanhToan}
{ThongTinHinhThuc}
{endloop_TTHD}
{beginKHTV}
----------------------------------------
Khách hàng thành viên
Khách hàng                      {MaKHTV}
{endKHTV}
----------------------------------------
NV: {MaNV}
Tên NV: {TenNV}
Số HĐ:{SoHD}
{GhiChu}`;

  receiptformat_2inch =
`Quầy: {TenQuay} - {MaCH}
Ngày: {NgayThangNam}
------------------------------
Đơn giá   SL   Thành Tiền
{beginloop}
{MaHH}          {LoaiVAT}
{TenHH}
{GiaBan}  {SoLuong}  {ThanhTienBan}
{GiaKM}
{endloop}
-------------------------------
Tổng  {Sum(SoLuong)} {Sum(TriGiaBan)}
Chiết khấu          {Sum(ChietKhau)}
Tổng tiền        {Sum(ThanhTienBan)}
Tiền khách trả   {Sum(SoTienThanhToan)}
Tiền trả lại     {Sum(TienTraLaiKhach)}
-------------------------------
Chi tiết tiền thuế
VAT                     TienVAT
{beginloop_VAT}
{LoaiVAT}            {TriGiaVAT}
{endloop_VAT}
-------------------------------
Chi tiết thanh toán
{beginloop_TTHD}
{TenHinhThuc}   {SoTienThanhToan}
{ThongTinHinhThuc}
{endloop_TTHD}
{beginKHTV}
-------------------------------
Khách hàng thành viên
Khách hàng             {MaKHTV}
{endKHTV}
-------------------------------
NV: {MaNV}
Tên NV: {TenNV}
Số HĐ:{SoHD}
{GhiChu}`;
  receiptformat_2inch_grd =
`Ngày: {NgayThangNam}
N.viên: {TenNV}   Số HĐ:{SoHD}
------------------------------
Sản Phẩm   SL   Thành Tiền
{beginloop}
{MaHH}          
{TenHH}
{GiaBan}  {SoLuong}  {ThanhTienBan}
{GiaKM}
{endloop}
-------------------------------
Tổng  {Sum(SoLuong)} {Sum(TriGiaBan)}
{beginloop_TTHD}
{TenHinhThuc}   {SoTienThanhToan}
{ThongTinHinhThuc}
{endloop_TTHD}
Tiền khách trả   {Sum(SoTienThanhToan)}
Tiền thối     {Sum(TienTraLaiKhach)}
-------------------------------
{GhiChu}`;

  endshiftformat_3inch =
`Quầy: {TenQuay} - {MaCH}             {NgayThangNam}
----------------------------------------
Tổng số hóa đơn đã bán: {TongSoHoaDon}
Tổng thanh toán trong ca
{beginloop_TTHD}
{TenHinhThuc}          {SoTienThanhToan}
{endloop_TTHD}
----------------------------------------
NV: {MaNV}
Tên NV: {TenNV}`;

  endshiftformat_2inch =
`Quầy: {TenQuay} - {MaCH}
Ngày: {NgayThangNam}
-------------------------------
Tổng số hóa đơn đã bán: {TongSoHoaDon}
Tổng thanh toán trong ca
{beginloop_TTHD}
{TenHinhThuc}   {SoTienThanhToan}
{endloop_TTHD}    
-------------------------------
NV: {MaNV}
Tên NV: {TenNV}`;

  url: any;
  config_bill_width: any;
  billType: string;
  width_3inch = 40;
  width_2inch = 31;
  width_bill = 40;
  constructor(
    private http: HttpClient,
    private jwtService: JWTService,
    private storeHTTT: Store<HTTT>,
    private getlocalconfig: GetLocalForageConFigService,
    @Inject('BASE_URL') baseUrl: string,
  ) {
    this.url = baseUrl;
    this.http.get('manifest.json', { responseType: 'json' }).subscribe(async name => {
      this.config_bill_width = +(await name['width_bill_inch']);
      this.billType = (await name['bill_type']);
      // if(this.config_bill_width === '2')
      // {
      //   this.receiptformat = this.receiptformat_2inch;
      //   this.width_bill = this.width_2inch;
      // }
      // else {
      //   this.receiptformat = this.receiptformat_3inch;
      //   this.width_bill = this.width_3inch;
      // }
    });
  }

  splitted_receiptformat(): Array<string> {
    if (this.config_bill_width === 2) {
      if (this.billType.toLowerCase() == 'grd') {
        this.receiptformat = this.receiptformat_2inch_grd;
      }
      else {
        this.receiptformat = this.receiptformat_2inch;
      }
      this.width_bill = this.width_2inch;
    }
    else {
      this.receiptformat = this.receiptformat_3inch;
      this.width_bill = this.width_3inch;
    }
    const data: Array<string> = this.receiptformat.split(/[\r\n]+/);
    return data;
  }

  splitted_endshiftformat(): Array<string> {
    if (this.config_bill_width === 2) {
      this.receiptformat = this.endshiftformat_2inch;
      this.width_bill = this.width_2inch;
    }
    else {
      this.receiptformat = this.endshiftformat_2inch;
      this.width_bill = this.width_3inch;
    }
    const data: Array<string> = this.receiptformat.split(/[\r\n]+/);
    return data;
  }

  //----------------- Trí Thêm
  //splitted_receiptformat_ReturnItems(): Array<string> {
  //  if (this.config_bill_width === 2) {
  //    this.receiptformat = this.receiptformat_2inch_ReturnItems;
  //    this.width_bill = this.width_2inch;
  //  }
  //  else {
  //    this.receiptformat = this.receiptformat_3inch;
  //    this.width_bill = this.width_3inch;
  //  }
  //  const data: Array<string> = this.receiptformat.split(/[\r\n]+/);
  //  return data;
  //}

  async getCheckBill(id: string) {
    return this.http.post(`${this.url}api/HoaDon/getCheckHoaDon`,
      {
        HoaDonId: id
      }).toPromise()
      .then(result => result[0]);
  }

  async setBill(bill: HoaDon, payments: Array<TTHD>) {
    const list: Array<HTTTs> = new Array<HTTTs>();
    let MaKH: string;
    if (bill.MaKHTV) {
      MaKH = bill.MaKHTV;
    } else {
      MaKH = null;
    }
    payments.forEach(x => {
      const data: HTTTs = {
        MaHinhThuc: x.HTTT.MaHinhThuc,
        MaNhomThanhToan: x.HTTT.MaNhomThanhToan,
        TenNhom: x.HTTT.TenNhom,
        TenHinhThuc: x.HTTT.TenHinhThuc,
        DoUuTien: x.HTTT.DoUuTien,
        MaThe: x.HTTT.MaThe,
        SoTienThanhToanHD: x.SoTienThanhToanHD,
        QuyDoiNgoaiTe: x.QuyDoiNgoaiTe,
        TyLeQuyDoi: x.TyLeQuyDoi
      };
      list.push(data);
    });
    const bills: HD = {
      CTHoaDon: bill.CTHoaDons,
      HTThanhToan: list,
      HoaDonId: bill.HoaDonID,
      MaKHTV: MaKH,
      MaQuay: bill.MaQuay,
      MaNV: bill.MaNV,
      NgayHD: bill.NgayHD,
      STTHD: bill.STTHD,
      GhiChu: bill.GhiChu,
      LoaiHD: bill.LoaiHD,
      TongTien: bill.TongTien,
      TongTienCK: bill.TienCK,
      TienTraKhach: bill.TienTraKhach,
      MaHD: bill.MaHD,
      HDGoc: '',
      TongTienTraHang: 0
    };
    // const wrH: WrapHD = {
    //  Wraped: bills
    // };
    const arry: HD[] = [];
    arry.push(bills);
    const getDSHD = await localForage.getItem('_dsHD').then((result: any) => result);
    if (getDSHD !== null) {
      const dsHD = getDSHD;
      console.log('dsHD');
      console.log(dsHD);
      const deCryptDSHD = this.jwtService.deCryptData(dsHD);
      const listBills = JSON.parse(deCryptDSHD);
      const HDs: Array<HD> = listBills;
      // console.log(`*****Bill Thanh Toan*****`);
      // console.log(dsHD);
      // console.log(deCryptDSHD);
      // console.log(listBills);
      // console.log(listBillss);
      // console.log(`**********`);
      HDs.push(bills);
      const mahoaHoaDon = this.jwtService.enCryptData(HDs);
      this.getlocalconfig.getConfigLocalForage()
        .then(async result => {
          await localForage.setItem('_dsHD', mahoaHoaDon);
        });
      // console.log('HD');
      // console.log(HDs);
    } else {
      const mahoaHoaDon = this.jwtService.enCryptData(arry);
      this.getlocalconfig.getConfigLocalForage()
        .then(async result => {
          await localForage.setItem('_dsHD', mahoaHoaDon);
        });
    }
    return this.http.post(this.url + 'api/HoaDon/setHoaDon', {
      // value: bill
      CTHoaDon: bill.CTHoaDons,
      HTThanhToan: list,
      HoaDonId: bill.HoaDonID,
      MaKHTV: MaKH,
      MaQuay: bill.MaQuay,
      MaNV: bill.MaNV,
      NgayHD: bill.NgayHD,
      STTHD: bill.STTHD,
      GhiChu: bill.GhiChu,
      LoaiHD: bill.LoaiHD,
      TongTien: bill.TongTien,
      TienTraKhach: bill.TienTraKhach,
      TongTienCK: bill.TienCK,
      MaHD: bill.MaHD
    })
      .toPromise()
      .then(result => {
        return result;
      })
      .catch(err => console.log(err));
  }

  // ------------ Trí Thêm
  async setBill_TraHang(bill: HoaDon, payments: Array<TTHD>) {
    const list: Array<HTTTs> = new Array<HTTTs>();
    let MaKH: string;
    if (bill.MaKHTV) {
      MaKH = bill.MaKHTV;
    } else {
      MaKH = null;
    }
    payments.forEach(x => {
      const data: HTTTs = {
        MaHinhThuc: x.HTTT.MaHinhThuc,
        MaNhomThanhToan: x.HTTT.MaNhomThanhToan,
        TenNhom: x.HTTT.TenNhom,
        TenHinhThuc: x.HTTT.TenHinhThuc,
        DoUuTien: x.HTTT.DoUuTien,
        MaThe: x.HTTT.MaThe,
        SoTienThanhToanHD: x.SoTienThanhToanHD,
        QuyDoiNgoaiTe: x.QuyDoiNgoaiTe,
        TyLeQuyDoi: x.TyLeQuyDoi
      };
      list.push(data);
    });
    const bills: HD = {
      CTHoaDon: bill.CTHoaDons,
      HTThanhToan: list,
      HoaDonId: bill.HoaDonID,
      MaKHTV: MaKH,
      MaQuay: bill.MaQuay,
      MaNV: bill.MaNV,
      NgayHD: bill.NgayHD,
      STTHD: bill.STTHD,
      GhiChu: bill.GhiChu,
      LoaiHD: bill.LoaiHD,
      TongTien: bill.TongTien,
      TongTienCK: bill.TienCK,
      TienTraKhach: bill.TienTraKhach,
      HDGoc: bill.HDGoc,
      TongTienTraHang: bill.TongTienTraHang,
      MaHD: bill.MaHD
    };
    // const wrH: WrapHD = {
    //  Wraped: bills
    // };
    const arry: HD[] = [];
    arry.push(bills);
    const getDSHD = await localForage.getItem('_dsHD').then((result: any) => result);
    if (getDSHD !== null) {
      const dsHD = getDSHD;
      console.log('dsHD');
      console.log(dsHD);
      const deCryptDSHD = this.jwtService.deCryptData(dsHD);
      const listBills = JSON.parse(deCryptDSHD);
      const HDs: Array<HD> = listBills;
      // console.log(`*****Bill Thanh Toan*****`);
      // console.log(dsHD);
      // console.log(deCryptDSHD);
      // console.log(listBills);
      // console.log(listBillss);
      // console.log(`**********`);
      HDs.push(bills);
      const mahoaHoaDon = this.jwtService.enCryptData(HDs);
      this.getlocalconfig.getConfigLocalForage()
        .then(async result => {
          await localForage.setItem('_dsHD', mahoaHoaDon);
        });
      // console.log('HD');
      // console.log(HDs);
    } else {
      const mahoaHoaDon = this.jwtService.enCryptData(arry);
      this.getlocalconfig.getConfigLocalForage()
        .then(async result => {
          await localForage.setItem('_dsHD', mahoaHoaDon);
        });
    }
    return this.http.post(this.url + 'api/HoaDon/setHoaDon_TraHang', {
      // value: bill
      CTHoaDon: bill.CTHoaDons,
      HTThanhToan: list,
      HoaDonId: bill.HoaDonID,
      MaKHTV: MaKH,
      MaQuay: bill.MaQuay,
      MaNV: bill.MaNV,
      NgayHD: bill.NgayHD,
      STTHD: bill.STTHD,
      GhiChu: bill.GhiChu,
      LoaiHD: bill.LoaiHD,
      TongTien: bill.TongTien,
      TienTraKhach: bill.TienTraKhach,
      TongTienCK: bill.TienCK,
      HDGoc: bill.HDGoc,
      TongTienTraHang: bill.TongTienTraHang,
      MaHD: bill.MaHD
    })
      .toPromise()
      .then(result => {
        return result;
      })
      .catch(err => console.log(err));
  }


  async setBillLogout(bill: HoaDon, payments: Array<TTHD>) {
    const list: Array<HTTTs> = new Array<HTTTs>();
    let MaKH: string;
    if (bill.MaKHTV) {
      MaKH = bill.MaKHTV;
    } else {
      MaKH = null;
    }
    payments.forEach(x => {
      const data: HTTTs = {
        MaHinhThuc: x.HTTT.MaHinhThuc,
        MaNhomThanhToan: x.HTTT.MaNhomThanhToan,
        TenNhom: x.HTTT.TenNhom,
        TenHinhThuc: x.HTTT.TenHinhThuc,
        DoUuTien: x.HTTT.DoUuTien,
        MaThe: x.HTTT.MaThe,
        SoTienThanhToanHD: x.SoTienThanhToanHD
      };
      list.push(data);
    });
    return this.http.post(this.url + 'api/HoaDon/setHoaDon', {
      // value: bill
      CTHoaDon: bill.CTHoaDons,
      HTThanhToan: list,
      HoaDonId: bill.HoaDonID,
      MaKHTV: MaKH,
      MaQuay: bill.MaQuay,
      MaNV: bill.MaNV,
      NgayHD: bill.NgayHD,
      MaHD: bill.MaHD,
      STTHD: bill.STTHD,
      GhiChu: bill.GhiChu,
      LoaiHD: bill.LoaiHD,
      TongTien: bill.TongTien,
      TienTraKhach: bill.TienTraKhach,
      TongTienCK: bill.TienCK
    })
      .toPromise()
      .then(result => {
        return result;
      })
      .catch(err => console.log(err));
  }


  // ----------------------------- Trí Thêm
  async setBillLogout_ReturnItems(bill: HoaDon, payments: Array<TTHD>) {
    const list: Array<HTTTs> = new Array<HTTTs>();
    let MaKH: string;
    if (bill.MaKHTV) {
      MaKH = bill.MaKHTV;
    } else {
      MaKH = null;
    }
    payments.forEach(x => {
      const data: HTTTs = {
        MaHinhThuc: x.HTTT.MaHinhThuc,
        MaNhomThanhToan: x.HTTT.MaNhomThanhToan,
        TenNhom: x.HTTT.TenNhom,
        TenHinhThuc: x.HTTT.TenHinhThuc,
        DoUuTien: x.HTTT.DoUuTien,
        MaThe: x.HTTT.MaThe,
        SoTienThanhToanHD: x.SoTienThanhToanHD
      };
      list.push(data);
    });
    return this.http.post(this.url + 'api/HoaDon/setHoaDon_TraHang_SBU', {
      // value: bill
      CTHoaDon: bill.CTHoaDons,
      HTThanhToan: list,
      HoaDonId: bill.HoaDonID,
      MaKHTV: MaKH,
      MaQuay: bill.MaQuay,
      MaNV: bill.MaNV,
      NgayHD: bill.NgayHD,
      MaHD: bill.MaHD,
      STTHD: bill.STTHD,
      GhiChu: bill.GhiChu,
      LoaiHD: bill.LoaiHD,
      TongTien: bill.TongTien,
      TienTraKhach: bill.TienTraKhach,
      TongTienCK: bill.TienCK,
      HDGoc: bill.HDGoc,
      TongTienTraHang: bill.TongTienTraHang
    })
      .toPromise()
      .then(result => {
        return result;
      })
      .catch(err => console.log(err));
  }

  async getPayments(value: string) {
    return this.http.post(this.url + 'api/HoaDon/getHinhThucThanhToan', { MaCH: value })
      .toPromise()
      .then((result: ServerResponse) => {
        if (result[0].code === 1) {
          this.storeHTTT.dispatch({ type: 'INIT_HTTT', httt: result[0].data });
          // console.log('getPayments');
          // console.log(result[0]);
          return result[0].data;
        }
      });
  }

  async cancelBill(bill: HoaDon) {
    let MaKH: string;
    if (bill.MaKHTV) {
      MaKH = bill.MaKHTV;
    } else {
      MaKH = null;
    }
    const cancelBills: HD = {
      CTHoaDon: bill.CTHoaDons,
      // HTThanhToan: list,
      HoaDonId: bill.HoaDonID,
      MaKHTV: MaKH,
      MaQuay: bill.MaQuay,
      MaNV: bill.MaNV,
      NgayHD: bill.NgayHD,
      STTHD: bill.STTHD,
      GhiChu: bill.GhiChu,
      LoaiHD: bill.LoaiHD,
      TongTien: bill.TongTien,
      MaHD: bill.MaHD
    };
    const arryHDHuy: HD[] = [];
    arryHDHuy.push(cancelBills);
    const getDSHD = await localForage.getItem('_dsHD').then((result: any) => result);
    if (getDSHD !== null) {
      const dsHDHuy = getDSHD;
      const deCryptDSHDHuy = this.jwtService.deCryptData(dsHDHuy);
      // const listBillHuys = JSON.parse(listBillHuy);
      const listBillHuyss: HD[] = JSON.parse(deCryptDSHDHuy);
      //console.log(`*****Bill Huy*****`);
      //console.log(dsHDHuy);
      //console.log(deCryptDSHDHuy);
      //console.log(listBillHuys);
      //console.log(listBillHuyss);
      //console.log(`**********`);
      const HDHuys: Array<HD> = listBillHuyss;
      HDHuys.push(cancelBills);
      const mahoaHoaDonHuy = this.jwtService.enCryptData(HDHuys);
      this.getlocalconfig.getConfigLocalForage()
        .then(async result => {
          await localForage.setItem('_dsHD', mahoaHoaDonHuy);
        });
    } else {
      const mahoaHoaDonHuy = this.jwtService.enCryptData(arryHDHuy);
      this.getlocalconfig.getConfigLocalForage()
        .then(async result => {
          await localForage.setItem('_dsHD', mahoaHoaDonHuy);
        });
    }
    return this.http.post(this.url + 'api/HoaDon/cancelHoaDon', {
      CTHoaDon: bill.CTHoaDons,
      HoaDonId: bill.HoaDonID,
      MaKHTV: MaKH,
      MaQuay: bill.MaQuay,
      MaNV: bill.MaNV,
      NgayHD: bill.NgayHD,
      STTHD: bill.STTHD,
      LoaiHD: bill.LoaiHD,
      TongTien: bill.TongTien,
      MaHD: bill.MaHD
    })
      .toPromise()
      .then(result => {
        return result;
      });
  }

  async cancelBill_SBU(bill: HoaDon) {
    let MaKH: string;
    if (bill.MaKHTV) {
      MaKH = bill.MaKHTV;
    } else {
      MaKH = null;
    }
    const cancelBills: HD = {
      CTHoaDon: bill.CTHoaDons,
      // HTThanhToan: list,
      HoaDonId: bill.HoaDonID,
      MaKHTV: MaKH,
      MaQuay: bill.MaQuay,
      MaNV: bill.MaNV,
      NgayHD: bill.NgayHD,
      STTHD: bill.STTHD,
      GhiChu: bill.GhiChu,
      LoaiHD: bill.LoaiHD,
      TongTien: bill.TongTien
    };
   return this.http.post(this.url + 'api/HoaDon/cancelHoaDon_SBU', {
      CTHoaDon: bill.CTHoaDons,
      HoaDonId: bill.HoaDonID,
      MaKHTV: MaKH,
      MaQuay: bill.MaQuay,
      MaNV: bill.MaNV,
      NgayHD: bill.NgayHD,
     STTHD: bill.STTHD,
     GhiChu: bill.GhiChu,
      LoaiHD: bill.LoaiHD,
      TongTien: bill.TongTien
    })
      .toPromise()
      .then(result => {
        return result;
      })
      .catch(error => {
        throw error;
      });
  }

  async setBill_SBU(bill: HoaDon, payments: Array<TTHD>) {
    const list: Array<HTTTs> = new Array<HTTTs>();
    let MaKH: string;
    if (bill.MaKHTV) {
      MaKH = bill.MaKHTV;
    } else {
      MaKH = null;
    }
    payments.forEach(x => {
      const data: HTTTs = {
        MaHinhThuc: x.HTTT.MaHinhThuc,
        MaNhomThanhToan: x.HTTT.MaNhomThanhToan,
        TenNhom: x.HTTT.TenNhom,
        TenHinhThuc: x.HTTT.TenHinhThuc,
        DoUuTien: x.HTTT.DoUuTien,
        MaThe: x.HTTT.MaThe,
        SoTienThanhToanHD: x.SoTienThanhToanHD
      };
      list.push(data);
    });
    const bills: HD = {
      CTHoaDon: bill.CTHoaDons,
      HTThanhToan: list,
      HoaDonId: bill.HoaDonID,
      MaKHTV: MaKH,
      MaQuay: bill.MaQuay,
      MaNV: bill.MaNV,
      NgayHD: bill.NgayHD,
      GhiChu: bill.GhiChu,
      MaHD: bill.MaHD,
      STTHD: bill.STTHD,
      LoaiHD: bill.LoaiHD,
      TongTien: bill.TongTien,
      TienTraKhach: bill.TienTraKhach
    };
    const arry: HD[] = [];
    arry.push(bills);
    return this.http.post(this.url + 'api/HoaDon/setHoaDon_SBU', {
      CTHoaDon: bill.CTHoaDons,
      HTThanhToan: list,
      HoaDonId: bill.HoaDonID,
      MaKHTV: MaKH,
      MaQuay: bill.MaQuay,
      MaNV: bill.MaNV,
      NgayHD: bill.NgayHD,
      GhiChu: bill.GhiChu,
      MaHD: bill.MaHD,
      STTHD: bill.STTHD,
      LoaiHD: bill.LoaiHD,
      TongTien: bill.TongTien,
      TienTraKhach: bill.TienTraKhach
    })
      .toPromise()
      .then(result => {
        return result;
      })
      .catch(err => console.log(err));
  }
  
  async setBillOffline(bill: HoaDon, payments: Array<TTHD>) {
    const list: Array<HTTTs> = new Array<HTTTs>();
    let MaKH: string;
    if (bill.MaKHTV) {
      MaKH = bill.MaKHTV;
    } else {
      MaKH = null;
    }
    if (bill.LoaiHD === 1 || bill.LoaiHD === 3 || bill.LoaiHD === 5) {
      payments.forEach(x => {
        const data: HTTTs = {
          MaHinhThuc: x.HTTT.MaHinhThuc,
          MaNhomThanhToan: x.HTTT.MaNhomThanhToan,
          TenNhom: x.HTTT.TenNhom,
          TenHinhThuc: x.HTTT.TenHinhThuc,
          DoUuTien: x.HTTT.DoUuTien,
          MaThe: x.HTTT.MaThe,
          SoTienThanhToanHD: x.SoTienThanhToanHD
        };
        list.push(data);
      });
    }
    const bills: HD = {
      CTHoaDon: bill.CTHoaDons,
      HTThanhToan: list,
      HoaDonId: bill.HoaDonID,
      MaKHTV: MaKH,
      MaQuay: bill.MaQuay,
      MaNV: bill.MaNV,
      NgayHD: bill.NgayHD,
      HDGoc: bill.HDGoc,
      TongTienTraHang: bill.TongTienTraHang,
      MaHD: bill.MaHD,
      STTHD: bill.STTHD,
      GhiChu: bill.GhiChu,
      LoaiHD: bill.LoaiHD,
      TongTien: bill.TongTien,
      TongTienCK: bill.TienCK,
      TienTraKhach: bill.TienTraKhach
    };
    const arry: HD[] = [];
    arry.push(bills);
    const getDSHD = await localForage.getItem('_dsHD').then((result: any) => result);
    if (getDSHD !== null) {
      const dsHD = getDSHD;
      console.log('dsHD');
      console.log(dsHD);
      const deCryptDSHD = this.jwtService.deCryptData(dsHD);
      const listBills = JSON.parse(deCryptDSHD);
      const HDs: Array<HD> = listBills;
      HDs.push(bills);
      const mahoaHoaDon = this.jwtService.enCryptData(HDs);
      return this.getlocalconfig.getConfigLocalForage()
        .then(async result => {
          await localForage.setItem('_dsHD', mahoaHoaDon);
          return true;
        });
    } else {
      const mahoaHoaDon = this.jwtService.enCryptData(arry);
      return this.getlocalconfig.getConfigLocalForage()
        .then(async result => {
          await localForage.setItem('_dsHD', mahoaHoaDon);
          return true;
        });
    }
  }

  saveBillRefresh(order: HoaDon) {
    this.getlocalconfig.getConfigLocalForage()
      .then(async result => {
        await localForage.setItem('_curHD', JSON.stringify(order));
      });
  }

  saveWaitingBillRefresh(orderWait: Array<HoaDon>) {
    this.getlocalconfig.getConfigLocalForage()
      .then(async result => {
        await localForage.setItem('_curHDDoi', JSON.stringify(orderWait));
      });
  }

  saveTotalBillRefresh(total_bill: Array<HoaDon>) {
    this.getlocalconfig.getConfigLocalForage()
      .then(async result => {
        await localForage.setItem('_curHDTong', JSON.stringify(total_bill));
      });
  }

  Generate_Receipt(receipt_structure, TenQuay, NgayHD, MaNV, TenNV, SoHD, CTHDs: CTHoaDon[], TTHDs: TTHD[], ChietKhau, MaCH: string, ghichu?: string): string[] {
    const result = receipt_structure;
    let sumsoluong = 0;
    let sumthanhtien = 0;
    let sumthanhtiencoCK = 0;
    for (const cthd of CTHDs) {
      //if (cthd.TienCK === 0 && cthd.TyLeCK === 0) {
        sumsoluong += cthd.SoLuong;
        sumthanhtien += (cthd.DGBan * cthd.SoLuong);
        sumthanhtiencoCK += (cthd.DGBanCK * cthd.SoLuong);
      //}
      //else if (cthd.TyLeCK !== 0)
      //{
      //  let dgbanck_tyle = cthd.DGBan - ((cthd.DGBan / 100) * cthd.TyLeCK);
      //  sumsoluong += cthd.SoLuong;
      //  sumthanhtien += (cthd.DGBan * cthd.SoLuong);
      //  sumthanhtiencoCK += (dgbanck_tyle * cthd.SoLuong);
      //}
      //else
      //{
      //  let dgbanck_tien = cthd.DGBan - cthd.TienCK;
      //  sumsoluong += cthd.SoLuong;
      //  sumthanhtien += (cthd.DGBan * cthd.SoLuong);
      //  sumthanhtiencoCK += (dgbanck_tien * cthd.SoLuong);
      //}
    }
    let tienCKTong = sumthanhtien - sumthanhtiencoCK;
    let sumtienthanhtoan = 0;
    for (const tthd of TTHDs) {
      sumtienthanhtoan += tthd.SoTienThanhToanHD;
    }
    const sumtientralaikhach = sumtienthanhtoan - sumthanhtiencoCK;

    result.forEach((data, l) => {
      result[l] = result[l].replace('{TenQuay}', TenQuay);
      result[l] = result[l].replace('{MaCH}', MaCH);

      result[l] = result[l].replace('{NgayThangNam}', NgayHD);

      result[l] = result[l].replace('{MaNV}', MaNV);

      if (this.billType.toLowerCase() == 'grd') {
        result[l] = result[l].replace('{TenNV}', layTen(TenNV));
      }
      else {
        result[l] = result[l].replace('{TenNV}', catChuoi(TenNV, 20));
      }

      result[l] = result[l].replace('{SoHD}', TPCloud_isNumber(SoHD, 4));

      if (ghichu != null && ghichu.length > 1 ) {       
        result[l] = result[l].replace('{GhiChu}', 'Ghi chú: ' + this.customSplit_ghiChu(ghichu, this.width_bill - 9, this.width_bill));
      }
      else {
        result[l] = result[l].replace('{GhiChu}', '');
      }

      result[l] = result[l].replace('{Sum(SoLuong)}', FormatSoTien(sumsoluong) + ' ');

      result[l] = result[l].replace('{Sum(ThanhTienBan)}', FormatSoTien(sumthanhtiencoCK.toFixed(2)));

      result[l] = result[l].replace('{Sum(TriGiaBan)}', FormatSoTien(sumthanhtien.toFixed(2)));

      result[l] = result[l].replace('{Sum(SoTienThanhToan)}', FormatSoTien(sumtienthanhtoan.toFixed(2)));

      result[l] = result[l].replace('{Sum(TienTraLaiKhach)}', FormatSoTien(sumtientralaikhach.toFixed(2)));

      result[l] = result[l].replace('{Sum(ChietKhau)}', FormatSoTien(tienCKTong.toFixed(2)));
    }); 
    return result;
  }

  Generate_Receipt_endshift(receipt_structure, TenQuay, NgayHD, MaNV, TenNV,MaCH): string[] {
    const result = receipt_structure;    
    result.forEach((data, l) => {
      result[l] = result[l].replace('{TenQuay}', TenQuay);
      result[l] = result[l].replace('{MaCH}', MaCH);

      result[l] = result[l].replace('{NgayThangNam}', NgayHD);

      result[l] = result[l].replace('{MaNV}', MaNV);

      result[l] = result[l].replace('{TenNV}', catChuoi(TenNV, 20));
    });
    return result;
  }


  // ------------------- Trí Thêm
  //Generate_Receipt_returnItems(receipt_structure, TenQuay, NgayHD, MaNV, TenNV, SoHD, CTHDs: CTHoaDon[], TTHDs: TTHD[], ChietKhau, value, MaCH): string[] {
  //  const result = receipt_structure;
  //  let sumsoluong = 0;
  //  let sumthanhtien = 0;
  //  let sumthanhtiencoCK = 0;
  //  for (const cthd of CTHDs) {
  //    if (cthd.checked == true && value == "ManyReturn_Items") {
  //      sumsoluong += cthd.SoLuong;
  //      sumthanhtien += cthd.DGBan * cthd.SoLuong;
  //      sumthanhtiencoCK += cthd.DGBanCK * cthd.SoLuong;
  //    } else if (cthd.checked == undefined && value == "AllReturn_Items") {
  //      sumsoluong += cthd.SoLuong;
  //      sumthanhtien += cthd.DGBan * cthd.SoLuong;
  //      sumthanhtiencoCK += cthd.DGBanCK * cthd.SoLuong;
  //    }
  //  }
  //  let tienCKTong = sumthanhtien - sumthanhtiencoCK;
  //  let sumtienthanhtoan = 0;
  //  for (const tthd of TTHDs) {
  //    sumtienthanhtoan = sumtienthanhtoan + tthd.SoTienThanhToanHD;
  //  }
  //  const sumtientralaikhach = 0;

  //  result.forEach((data, l) => {
  //    result[l] = result[l].replace('{TenQuay}', TenQuay);
  //    result[l] = result[l].replace('{MaCH}', MaCH);
  //    result[l] = result[l].replace('{NgayThangNam}', NgayHD);

  //    result[l] = result[l].replace('{MaNV}', MaNV);

  //    result[l] = result[l].replace('{TenNV}', catChuoi(TenNV, 20));

  //    result[l] = result[l].replace('{SoHD}', TPCloud_isNumber(SoHD, 4));

  //    result[l] = result[l].replace('{Sum(SoLuong)}', FormatSoTien(sumsoluong) + ' ');

  //    result[l] = result[l].replace('{Sum(ThanhTienBan)}', FormatSoTien(sumthanhtiencoCK));

  //    result[l] = result[l].replace('{Sum(TriGiaBan)}', FormatSoTien(sumthanhtien));

  //    result[l] = result[l].replace('{Sum(SoTienThanhToan)}', FormatSoTien(sumtienthanhtoan));

  //    result[l] = result[l].replace('{Sum(TienTraLaiKhach)}', FormatSoTien(sumtientralaikhach));

  //    result[l] = result[l].replace('{Sum(ChietKhau)}', FormatSoTien(tienCKTong));
  //  });
  //  // ----------------- code cũ còn sài ---------------------------
  //  // for (const l in result) {
  //  //   result[l] = result[l].replace('{TenQuay}', TenQuay);

  //  //   result[l] = result[l].replace('{NgayThangNam}', NgayHD);

  //  //   result[l] = result[l].replace('{MaNV}', MaNV);

  //  //   result[l] = result[l].replace('{TenNV}', catChuoi(TenNV, 10));

  //  //   result[l] = result[l].replace('{SoHD}', TPCloud_isNumber(SoHD, 4));

  //  //   result[l] = result[l].replace('{Sum(SoLuong)}', FormatSoTien(sumsoluong) + ' ');

  //  //   result[l] = result[l].replace('{Sum(ThanhTienBan)}', FormatSoTien(sumthanhtien));

  //  //   result[l] = result[l].replace('{Sum(SoTienThanhToan)}', FormatSoTien(sumtienthanhtoan));

  //  //   result[l] = result[l].replace('{Sum(TienTraLaiKhach)}', FormatSoTien(sumtientralaikhach));

  //  //   result[l] = result[l].replace('{Sum(ChietKhau)}', FormatSoTien(ChietKhau));
  //  // }
  //  return result;
  //}


  Generate_Receipt_HH(receipt_structure, CTHDs: CTHoaDon[]): string[] {
    const result = receipt_structure;
    let index_beginloop;
    let index_endloop;
    const CTHD_format: string[] = [];
    result.forEach((data, l) => {
      if (result[l].search('{beginloop}') !== -1) {
        index_beginloop = l;
      }
      if (result[l].search('{endloop}') !== -1) {
        index_endloop = l;
      }
    });

    for (const l in result) {
      if (l > index_beginloop && l < index_endloop) {
        CTHD_format.push(result[l].toString());
      }
    }

    const cthd_result = [];
    for (const cthd of CTHDs) {
      let loop_format: string[] = [];
      loop_format = [...CTHD_format];
      loop_format.forEach((data, i) => {
        loop_format[i] = loop_format[i].replace('{STT}', (CTHDs.indexOf(cthd) + 1).toString());
        loop_format[i] = loop_format[i].replace('{TenHH}', catChuoi(cthd.TenHH, 30));
        loop_format[i] = loop_format[i].replace('{LoaiVAT}', 'VAT'+cthd.VATDauRa+'%');
        loop_format[i] = loop_format[i].replace('{MaHH}', cthd.MaHH);
        loop_format[i] = loop_format[i].replace('{GiaBan}', FormatSoTien(cthd.DGBanCK.toString()));
        loop_format[i] = loop_format[i].replace('{SoLuong}', cthd.SoLuong.toString());
        loop_format[i] = loop_format[i].replace('{ThanhTienBan}', FormatSoTien((cthd.DGBanCK * cthd.SoLuong).toFixed(2)));
        if (cthd.DGBan != cthd.DGBanCK) {
          loop_format[i] = loop_format[i].replace('{GiaKM}', 'Giá gốc:' + FormatSoTien(cthd.DGBan.toString()));
        }
        else {
          if (loop_format[i].endsWith('{GiaKM}')) {
            loop_format.splice(i, 1);
            return;
          }          
        }
        cthd_result.push(loop_format[i].toString());
      });
    }
    return cthd_result;
  }

  // ----------------- Trí thêm
  //Generate_Receipt_HH_ReturnItems(receipt_structure, CTHDs: CTHoaDon[], value): string[] {
  //  const result = receipt_structure;
  //  let index_beginloop;
  //  let index_endloop;
  //  const CTHD_format: string[] = [];
  //  result.forEach((data, l) => {
  //    if (result[l].search('{beginloop}') !== -1) {
  //      index_beginloop = l;
  //    }
  //    if (result[l].search('{endloop}') !== -1) {
  //      index_endloop = l;
  //    }
  //  });

  //  for (const l in result) {
  //    if (l > index_beginloop && l < index_endloop) {
  //      CTHD_format.push(result[l].toString());
  //    }
  //  }

  //  const cthd_result = [];
  //  for (const cthd of CTHDs) {
  //    if (cthd.checked == true && value == "ManyReturn_Items") {
  //      let loop_format: string[] = [];
  //      loop_format = [...CTHD_format];
  //      loop_format.forEach((data, i) => {
  //        loop_format[i] = loop_format[i].replace('{STT}', (CTHDs.indexOf(cthd) + 1).toString());
  //        loop_format[i] = loop_format[i].replace('{TenHH}', catChuoi(cthd.TenHH, 30));
  //        loop_format[i] = loop_format[i].replace('{LoaiVAT}', 'VAT' + cthd.VATDauRa + '%');
  //        loop_format[i] = loop_format[i].replace('{MaHH}', cthd.MaHH);
  //        loop_format[i] = loop_format[i].replace('{GiaBan}', FormatSoTien(cthd.DGBanCK.toString()));
  //        loop_format[i] = loop_format[i].replace('{SoLuong}', cthd.SoLuong.toString());
  //        loop_format[i] = loop_format[i].replace('{ThanhTienBan}', FormatSoTien((cthd.DGBanCK * cthd.SoLuong).toFixed(2)));
  //        if (cthd.DGBan != cthd.DGBanCK) {
  //          loop_format[i] = loop_format[i].replace('{GiaKM}', 'Giá gốc:' + FormatSoTien(cthd.DGBan.toString()));
  //        }
  //        else {
  //          if (loop_format[i].endsWith('{GiaKM}')) {
  //            loop_format.splice(i, 1);
  //            return;
  //          }
  //        }          cthd_result.push(loop_format[i].toString());
  //      });
  //    } else if (cthd.checked == undefined && value == "AllReturn_Items") {
  //      let loop_format: string[] = [];
  //      loop_format = [...CTHD_format];
  //      loop_format.forEach((data, i) => {
  //        loop_format[i] = loop_format[i].replace('{STT}', (CTHDs.indexOf(cthd) + 1).toString());
  //        loop_format[i] = loop_format[i].replace('{TenHH}', catChuoi(cthd.TenHH, 30));
  //        loop_format[i] = loop_format[i].replace('{LoaiVAT}', 'VAT' + cthd.VATDauRa + '%');
  //        loop_format[i] = loop_format[i].replace('{MaHH}', cthd.MaHH);
  //        loop_format[i] = loop_format[i].replace('{GiaBan}', FormatSoTien(cthd.DGBanCK.toString()));
  //        loop_format[i] = loop_format[i].replace('{SoLuong}', cthd.SoLuong.toString());
  //        loop_format[i] = loop_format[i].replace('{ThanhTienBan}', FormatSoTien((cthd.DGBanCK * cthd.SoLuong).toFixed(2)));
  //        if (cthd.DGBan != cthd.DGBanCK) {
  //          loop_format[i] = loop_format[i].replace('{GiaKM}', 'Giá gốc:' + FormatSoTien(cthd.DGBan.toString()));
  //        }
  //        else {
  //          if (loop_format[i].endsWith('{GiaKM}')) {
  //            loop_format.splice(i, 1);
  //            return;
  //          }
  //        }          cthd_result.push(loop_format[i].toString());
  //      });
  //    }
  //  }
  //  return cthd_result;
  //}

  Generate_Receipt_TTHD(receipt_structure, TTHDs: TTHD[]): string[] {
    const result = receipt_structure;
    let index_beginloop;
    let index_endloop;
    const TTHD_format: string[] = [];
    result.forEach((data, l) => {
      if (result[l].search('{beginloop_TTHD}') !== -1) {
        index_beginloop = l;
      }
      if (result[l].search('{endloop_TTHD}') !== -1) {
        index_endloop = l;
      }
    });

    for (const l in result) {
      if (l > index_beginloop && l < index_endloop) {
        TTHD_format.push(result[l].toString());
      }
    }
    const tthd_result = [];
    let sumtienthanhtoan = 0;
    for (const tthd of TTHDs) {
      sumtienthanhtoan += tthd.SoTienThanhToanHD;
      let loop_format: string[] = [];
      loop_format = [...TTHD_format];
      if (tthd.HTTT.MaNhomThanhToan !== '003' && tthd.HTTT.MaNhomThanhToan !== '013'
        && tthd.HTTT.MaNhomThanhToan !== '201' && tthd.HTTT.MaNhomThanhToan !== '202') {
        loop_format.splice(-1, 1);
      }
      loop_format.forEach((data, i) => {
        loop_format[i] = loop_format[i].replace('{TenHinhThuc}', tthd.HTTT.TenHinhThuc);
        loop_format[i] = loop_format[i].replace('{SoTienThanhToan}', FormatSoTien(tthd.SoTienThanhToanHD.toFixed(2)).toString());
        if (tthd.HTTT.MaNhomThanhToan === '003' || tthd.HTTT.MaNhomThanhToan === '013' ) {
          loop_format[i] = loop_format[i].replace('{ThongTinHinhThuc}', 'Mã tham chiếu: ' + tthd.HTTT.MaThe);
        }
        if (tthd.HTTT.MaNhomThanhToan === '201' || tthd.HTTT.MaNhomThanhToan === '202') {
          loop_format[i] = loop_format[i].replace('{ThongTinHinhThuc}', 'Mã tham chiếu: ' + tthd.HTTT.MaThe);
        }      
        tthd_result.push(loop_format[i].toString());
      });
    }
    return tthd_result;
  }

  Generate_Receipt_VAT(receipt_structure, CTHDs: CTHoaDon[]): string[] {
    const result = receipt_structure;
    let index_beginloop;
    let index_endloop;
    const VATHD_format: string[] = [];
    const uniques = new Set(CTHDs.map(i => i.VATDauRa));
    result.forEach((data, l) => {
      if (result[l].search('{beginloop_VAT}') !== -1) {
        index_beginloop = l;
      }
      if (result[l].search('{endloop_VAT}') !== -1) {
        index_endloop = l;
      }
    });
    for (const l in result) {
      if (l > index_beginloop && l < index_endloop) {
        VATHD_format.push(result[l].toString());
      }
    }
    const lstcountVat: Array<VATCount> = new Array<VATCount>();
    uniques.forEach(u => {
      const e = { VAT: u, count: 0, SumVAT: 0 };
      lstcountVat.push(e);
    }
    );
    const vathd_result = [];
    for (const cthd of CTHDs) {

      for (const Vatc of lstcountVat) {
        switch (cthd.VATDauRa) {
          case Vatc.VAT:
            {
              Vatc.count += 1;
              Vatc.SumVAT += (cthd.DGBanCK * cthd.SoLuong) - ((cthd.DGBanCK * cthd.SoLuong) / (1 + cthd.VATDauRa / 100));
              break;
            }
        }
      }
    }
    for (const vat of lstcountVat) {
      if (vat.count > 0) {
        let loop_format: string[] = [];
        loop_format = [...VATHD_format];
        loop_format.forEach((data, i) => {
          loop_format[i] = loop_format[i].replace('{LoaiVAT}', vat.VAT.toString() + '%');
          loop_format[i] = loop_format[i].replace('{TriGiaVAT}', (FormatSoTien(Math.round(vat.SumVAT * 100) / 100)).toString());
        });
        vathd_result.push(loop_format.toString());
      }
    }
    return vathd_result;
  }

  Generate_Receipt_Customer(receipt_structure: any, MaKHTV?: any, TenKHTV?: any) {
    const result = receipt_structure;
    let index_beginloop;
    let index_endloop;
    const KHTV_format: string[] = [];
    // const uniques = new Set(CTHDs.map(i => i.VATDauRa));
    result.forEach((data, l) => {
      if (result[l].search('{beginKHTV}') !== -1) {
        index_beginloop = l;
      }
      if (result[l].search('{endKHTV}') !== -1) {
        index_endloop = l;
      }
    });
    // ------- Code cũ còn sài -------
    // for (const l in result) {
    //   if (result[l].search('{beginKHTV}') !== -1) {
    //     index_beginloop = l;
    //   }
    //   if (result[l].search('{endKHTV}') !== -1) {
    //     index_endloop = l;
    //   }
    // }
    for (const l in result) {
      if (l > index_beginloop && l < index_endloop) {
        KHTV_format.push(result[l].toString());
      }
    }

    KHTV_format.forEach((data, l) => {
      KHTV_format[l] = KHTV_format[l].replace('{MaKHTV}', MaKHTV);
    });
    // ------- Code cũ còn sài -------
    // for (const l in KHTV_format) {
    //   KHTV_format[l] = KHTV_format[l].replace('{MaKHTV}', MaKHTV);
    // }

    return KHTV_format;
  }

  Add_VAT_to_Receipt(body, bodyVAT) {
    let result = body;
    let index_beginloop;
    let index_endloop;
    result.forEach((data, l) => {
      if (result[l].search('{beginloop_VAT}') !== -1) {
        index_beginloop = l;
      }
      if (result[l].search('{endloop_VAT}') !== -1) {
        index_endloop = l;
      }
    });
    const end: number = +index_endloop + 1;
    const topbody = result.slice(0, index_beginloop);
    const botbody = result.slice(end, result.length);
    result = [...topbody, ...bodyVAT];
    result = [...result, ...botbody];
    return result;
  }

  Add_CTHH_to_Receipt(body, bodyCT) {
    let result = body;
    let index_beginloop;
    let index_endloop;
    result.forEach((data, l) => {
      if (result[l].search('{beginloop}') !== -1) {
        index_beginloop = l;
      }
      if (result[l].search('{endloop}') !== -1) {
        index_endloop = l;
      }
    });
    const end: number = +index_endloop + 1;
    const topbody = result.slice(0, index_beginloop);
    const botbody = result.slice(end, result.length);
    result = [...topbody, ...bodyCT];
    result = [...result, ...botbody];
    return result;
  }

  Add_TTHD_to_Receipt(body, bodyTT) {
    let result = body;
    let index_beginloop;
    let index_endloop;
    const TTHD_format: string[] = [];
    result.forEach((data, l) => {
      if (result[l].search('{beginloop_TTHD}') !== -1) {
        index_beginloop = l;
      }
      if (result[l].search('{endloop_TTHD}') !== -1) {
        index_endloop = l;
      }
    });
    const end: number = +index_endloop + 1;
    const topbody = result.slice(0, index_beginloop);
    const botbody = result.slice(end, result.length);
    result = [...topbody, ...bodyTT];
    result = [...result, ...botbody];
    return result;
  }

  Add_Customer_to_Receipt(body, bodyCustomer) {
    let result = body;
    let index_beginloop;
    let index_endloop;
    result.forEach((data, l) => {
      if (result[l].search('{beginKHTV}') !== -1) {
        index_beginloop = l;
      }
      if (result[l].search('{endKHTV}') !== -1) {
        index_endloop = l;
      }
    });

    // ---------------- code cũ còn sài --------------
    // for (const l in result) {
    //   if (result[l].search('{beginKHTV}') !== -1) {
    //     index_beginloop = l;
    //   }
    //   if (result[l].search('{endKHTV}') !== -1) {
    //     index_endloop = l;
    //   }
    // }
    const end: number = +index_endloop + 1;
    const topbody = result.slice(0, index_beginloop);
    const botbody = result.slice(end, result.length);
    if (body !== '') {
      result = [...topbody, ...bodyCustomer];
      result = [...result, ...botbody];
      return result;
    } else {
      result = [...topbody, ...botbody];
      return result;
    }
  }

  public reformat_receipt(first: string, second: string, third: string): string {
    const length = Math.floor((this.width_bill - second.length) / 2);
    let length1st = length;
    const length3rd = length;
    if ((length * 2 + second.length) < this.width_bill) {
      length1st += 1;
    }
    const firstpar = first.padEnd(length1st, ' ');
    const lastpar = third.padStart(length3rd, ' ');
    // ----- test line 536 ---- 
    // const result = firstpar + second + lastpar;
    const result = (first.padEnd(length1st, ' ')) + second + third.padStart(length3rd, ' ');
    return result;
  }

  public fullline_reformat(t: string): string {
    let arr: Array<string> = new Array<string>();
    arr = t.split('  ');
    let name = '';
    let date = '';
    let text = '';
    let count = 0;
    arr.forEach(x => {
      if (x) {
        if (count === 0) {
          name = x.trim();
          count = 1;
        } else if (count === 1) {
          text = x.trim();
          count = 2;
        } else {
          date = x.trim();
        }
      }
    });
    if (date === '') {
      date = text;
      text = '';
    }
    const lenght = Math.floor((this.width_bill - text.length) / 2);
    let lenghtName = lenght;
    const lenghtDate = lenght;
    if ((lenght * 2) + text.length < this.width_bill) {
      lenghtName = lenghtName + 1;
    }
    const value = (name.padEnd(lenghtName, ' ') + text + date.padStart(lenghtDate, ' '));
    // this.data.push(value);
    return value;
  }
  public print_generate_bill(h: string, f: string, body: string, logoKH?: string, title: string = "PHIẾU TÍNH TIỀN", reprint:boolean = false, img_barc_mahd?:string, mahd?:string): string {
    let kqin = '<pre id="inztoimage" style="color: black" onclick="window.print()">'+'\n';
    //kqin += '<img src="' + logoKH +'" style = "margin-left:16mm; margin-right:16mm; object-fit:scale-down; width: 150px; height: 100px;" target=""/>' + '\n';
    if (this.billType.toLowerCase() !== 'cf') {
      kqin += '<img src="' + logoKH + '" style = "width: 220px;margin-left:0.5vw; object-fit:scale-down; height: 150px;  " target=""/>' + '\n';
    }
    //else {
    //  kqin += '<img src="' + logoKH + '" style = "width: 220px;margin-left:0.5vw; object-fit:scale-down; height: 150px; -webkit-filter: invert(1); filter: invert(1);" target=""/>' + '\n';

    //}
    kqin += '' + h + '\n';
    kqin += '\n';
    const tit = this.padcenter(title, ' ', 30, true);
    kqin += tit + '\n';
    if (reprint) {
        const mark_reprint = this.padcenter('(In lại)', ' ', 30, true);
      kqin += mark_reprint + '\n';
    }
    kqin += '\n';
    //if (this.billType.toLowerCase() == 'cf') {
    //  kqin += 'Có giá trị xuất HĐ GTGT trong ngày' + '\n';
    //}    
    kqin += body;
    kqin += '\n';
    if (img_barc_mahd != null) {
      kqin += '<img src="' + img_barc_mahd + '" style = "width: 220px; margin-left:0.5vw; object-fit:scale-up; height:50px"/>' + '\n';
      kqin += this.padcenter(mahd, ' ', 30, true) + '\n';
      kqin += this.padcenter('*****', ' ', 30, true) + '\n';
    }
    kqin += '' + f + '\n';
    kqin += '</pre>' + '\n';
    return kqin;
  }

  public printWaitBill(s, tench, tenquay, tennv, STTHD): string {
    let kqin = '<pre style="color: black">';
    kqin += 'Cửa hàng: ' + tench + '!' + '\n';
    kqin += 'Quầy: ' + tenquay + '\n';
    kqin += 'Nhân viên: ' + catChuoi(tennv,15) + '\n';
    kqin += 'Ngày: ' + s + '\n'; 
    kqin += '------------------------------------' + '\n';
    kqin += this.padcenter('HÓA ĐƠN ĐỢI',' ',this.width_bill,'') + '\n';
    kqin += '\n';
    kqin += '' + 'Hóa đơn đợi số: ' + STTHD.toString();
    kqin += '\n';
    kqin += '--------------------------------------' + '\n';
    kqin += '</pre>';
    return kqin;
  }

  getInvoiceToday(stt: number, maQuay: string, ngayChon?: string) {
    const date = TPCloud_getFormatDate();
    return this.http.post(`${this.url}api/HoaDon/getInvoiceToday`, {
      MaQuay: maQuay,
      Date: ngayChon,
      Stt: stt
    })
      .toPromise()
      .then((result: ServerResponse) => {
        if (result[0].code === 1) {
          const dsHD: HD = result[0].data;
          return dsHD;
        } else {
          throw new Error(result[0].message);
        }
      });
  }

 async getLastHD() {
    const getDSHD = await localForage.getItem('_dsHD').then((result: any) => result);
    if (getDSHD !== null) {
      const dsHD = getDSHD;   
      const deCryptDSHD = this.jwtService.deCryptData(dsHD);
      const listBills = JSON.parse(deCryptDSHD);
      const HDs: Array<HD> = listBills;
      return HDs[HDs.length - 1];
    }
  }

  Generate_EndofShift_TTHD(receipt_structure_endshift, tongHT: TongThanhToan[]): string[] {
    const result = receipt_structure_endshift;
    let index_beginloop;
    let index_endloop;
    const TTHD_format: string[] = [];
    result.forEach((data, l) => {
      if (result[l].search('{beginloop_TTHD}') !== -1) {
        index_beginloop = l;
      }
      if (result[l].search('{endloop_TTHD}') !== -1) {
        index_endloop = l;
      }
    });

    for (const l in result) {
      if (l > index_beginloop && l < index_endloop) {
        TTHD_format.push(result[l].toString());
      }
    }
    const tthd_result = [];
    let sumtienthanhtoan = 0;
    for (const tthd of tongHT) {
      let loop_format: string[] = [];
      loop_format = [...TTHD_format];

      loop_format.forEach((data, i) => {
        loop_format[i] = loop_format[i].replace('{TenHinhThuc}', tthd.TenHinhThuc);
        loop_format[i] = loop_format[i].replace('{SoTienThanhToan}', FormatSoTien(tthd.SoTienThanhToanHD).toString());
        tthd_result.push(loop_format[i].toString());
      });
    }
    return tthd_result;
  }

  Add_EndofShift_SHD(receipt_structure_endshift, tongSHD: number): string[] {
    const result = receipt_structure_endshift;
    result.forEach((data, l) => {
      result[l] = result[l].replace('{TongSoHoaDon}', tongSHD);
    });
    return result;
  }

  padcenter(str, ch, size, extra2right): string {

    var max = size;

    var parts = str.padStart(str.length + Math.floor((max - str.length) / 2), ' ')
      .padEnd(max, ' ');
      return parts;
  }

   customSplit_ghiChu(str, firstLength, afterLength) {
     if (str.length <= firstLength)
    return str;
  var reg = new RegExp(".{1," + firstLength + "}", "g");
     var parts = str.match(reg);
     var firstline = parts[0];
     parts.splice(0, 1);
     var restof_str = parts.join('');
     var reg2 = new RegExp(".{1," + afterLength + "}", "g");
     var parts2 = restof_str.match(reg2);
     var rslt = firstline + '\n' + parts2.join('\n');
     return rslt;
}

}




// WEBPACK FOOTER //
// ./src/app/services/bill.service.ts